import { Component, ElementRef, ViewChild, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { forEach } from 'lodash';

import { KeybindService, KeybindDescription, KEYBOARD_CODES } from '~/core/services';
import { ViewLevel } from '~/main/constants';

@Component({
  selector: 'base-property-search',
  templateUrl: './base-property-search.component.html',
  styleUrls: ['./base-property-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BasePropertySearchComponent implements OnInit, OnDestroy {
  @ViewChild('searchInput') searchInput: ElementRef;
  @Input() placeholder = 'Search';
  @Input() displayResults: any;
  @Input() viewLevel: ViewLevel;
  @Output() onPropertySelected: EventEmitter<any> = new EventEmitter<any>();
  searchInputModel = '';
  showSuggestions = false;
  term = new Subject<string>();

  hidePanel = false;

  onDestroy: Subject<BasePropertySearchComponent> = new Subject();

  private subscriptions: any[] = [];

  constructor(private element: ElementRef, private keybinds: KeybindService) { }

  ngOnInit() {

    Observable.fromEvent(document, 'click')
      .filter(event => !this.element.nativeElement.contains(event['target']))
      .merge(this.keybinds.bind(new KeybindDescription(KEYBOARD_CODES.escape)))
      .takeUntil(this.onDestroy)
      .filter(() => !this.hidePanel)
      .subscribe(() => {
        this.term.next(null);
        this.hidePanel = true;
      });
  }

  searchInputChange() {
    this.hidePanel = false;
    // this.showSuggestions = false;
    if (this.validatePropertySearch()) {
      this.term.next(this.searchInputModel);
    } else {
      this.term.next('');
      this.hidePanel = true;
    }
  }

  validatePropertySearch(): boolean {
    if (this.searchInputModel.trim().length <= 2){
       return false
    };
    // allowing only alphanumeric, spaces and characters like ,-_.
    let regex = new RegExp(/^[\w\,\\\/\.\-\s]+$/);
    if (regex.test(this.searchInputModel)) {
      return true;
    }
    return false;
  }

  ngOnDestroy() {
    this.onDestroy.next(this);
    this.onDestroy.complete();

    forEach(this.subscriptions, (s) => s.unsubscribe());
    this.subscriptions = [];
    this.onPropertySelected.complete();
  }

  onPlaceSelected(place: any) {
    this.term.next(null);
    this.showSuggestions = false;
    this.hidePanel = true;
    this.searchInputModel = place.property.propertyName;
    this.onPropertySelected.emit(place);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/search/base-property-search.component.ts